import React, {Context} from "react";
import {GridComponentColumnProps} from "../../../core/_models";
import {BooleanGridColumnComponent} from "./BooleanGridColumnComponent";

type Props = {
    column: GridComponentColumnProps
    row: any
    context: Context<any>
    additionalRequestData?: { [key: string]: any }
    className?: string
}

export function GridColumnComponent({column, row, additionalRequestData, context, className = ''}: Props) {
    const isBoolean = column.type === 'BOOLEAN'
    return (
        <td key={`data-${column.field}-${row.id}`} className={`py-2 px-3 ${className}`}>
            {
                isBoolean
                && <BooleanGridColumnComponent
                    column={column}
                    row={row}
                    context={context}
                    additionalRequestData={additionalRequestData}
                />
            }
            {!isBoolean && <div dangerouslySetInnerHTML={{__html: row[column.field] ?? ''}}/>}
        </td>
    )
}